import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlContainer, FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent} from '@angular/material';
import {Subscription} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, map, startWith, switchMap} from 'rxjs/operators';
import {PleitoService} from '../../../service/pleito.service';
import {cnpjMask} from '../../masks/masks';

@Component({
  selector: 'app-autocomplete-empresa-pleito-cnpj',
  templateUrl: './autocomplete-empresa-pleito-cnpj.component.html'
})
export class AutocompleteEmpresaPleitoCnpjComponent implements OnInit, OnDestroy {

  @Input()
  label: string = 'CNPJ';

  @Input()
  controlName: string;

  @Input()
  isAnalista: boolean = false;

  @Output()
  selecionar: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  limpar: EventEmitter<string> = new EventEmitter<string>();

  empresas: string[];
  autocompleteSubscription: Subscription;
  protected mascaraCNPJ: string = cnpjMask;

  formControl: FormControl;

  constructor(
    private readonly pleitoService: PleitoService,
    private readonly controlContainer: ControlContainer
  ) {
  }

  inserirMascara(cnpj: string): string {
    switch (cnpj.length) {
      case 2:
        return `${cnpj}.`;
      case 6:
        return `${cnpj}.`;
      case 10:
        return `${cnpj}/`;
      case 15:
        return `${cnpj}-`;
      default:
        return cnpj;
    }
  }

  onPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const cleanedText = clipboardData.getData('text').replace(/\D/g, '');

    this.formControl.setValue(this.formatarCNPJ(cleanedText));

    event.preventDefault();
  }

  onKeyDown(event: KeyboardEvent): void {
    const keyCode = event.keyCode;
    if ((keyCode >= 65 && keyCode <= 90) ||
      (keyCode >= 97 && keyCode <= 122) ||
      (keyCode >= 186 && keyCode <= 192) ||
      (keyCode >= 219 && keyCode <= 222)) {
      if (!(event.ctrlKey && String.fromCharCode(keyCode).toLowerCase() === 'v')) {
        event.preventDefault();
      }
    }
    if (this.formControl.value.length < 18) {
      let inputValue = this.formControl.value || '';
      const key = event.key;
      const isNumber = /^\d$/.test(key);
      if (isNumber) {
        inputValue = this.inserirMascara(inputValue);
        inputValue += key;
        this.formControl.setValue(inputValue);
        event.preventDefault();
      }
      if (keyCode === 8) {
        this.formControl.setValue(inputValue.slice(0, -1));
        event.preventDefault();
      }
    }
  }
  ngOnInit(): void {
    this.formControl = this.controlContainer.control.get(this.controlName) as FormControl;
    this.formControl.setValue('');
    this.empresas = [];
    this.initAutocomplete();
  }

  ngOnDestroy(): void {
    this.autocompleteSubscription.unsubscribe();
  }

  selecionarProduto($event: MatAutocompleteSelectedEvent): void {
    this.formControl.patchValue($event.option.value);
    this.formControl.disable();
    this.selecionar.emit(this.formatarCNPJ($event.option.value));
  }

  limparSelecionado(): void {
    const empresa: string = this.formControl.value;
    this.formControl.patchValue(null);
    this.formControl.enable();
    this.empresas.length = 0;
    this.limpar.emit(empresa);
  }

  exibirProdutoNome(empresa): string {
    return empresa ? empresa : undefined;
  }

  formatarCNPJ(cnpj: string): string {
    if (cnpj) {
      return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }
    return '';
  }

  private initAutocomplete(): void {
    this.autocompleteSubscription = this.formControl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      distinctUntilChanged(),
      filter(nome => nome && nome.length >= 2),
      map(empresa => empresa.replace(/\D/g, '')),
      switchMap(empresa => {
        if (this.isAnalista === true) {
          return this.pleitoService.obterPorCNPJEmpresaAnalista(empresa)
        } else {
          return this.pleitoService.obterPorCNPJEmpresa(empresa)
        }
      })
    ).subscribe(empresas => {
      this.empresas = empresas;
    });
  }
}
